/**
 * @file action
 */
 import request from '@/common/request';
// login
 export async function getLoginUrl(params) {
    return await request({
        method: 'post',
        url: '/admin/api/user/V1.0/login',
        params: params,
        'x-message': false
    });
}

// 用户信息
export async function getUserInfo(params) {
    return await request({
        method: "get",
        url: "/admin/api/user/V1.0/username",
        params: params
    });
}
// logout
export async function logoutUrl(params) {
    return await request({
        method: "post",
        url: "/admin/api/user/V1.0/loginOut",
        params: params
    });
}
